import { put } from "redux-saga/effects";

import { ApiCaller } from "../../config";
import { StudentAction } from "../actions";

export default class StudentMiddleware {
  static *getAllStudents({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/school/filter-students?schoolId=${payload?.schoolId}&search=${
          payload.search ?? ""
        }&status=${payload.status ?? ""}&grade=${payload.grade ?? ""}&limit=${
          payload.limit ?? ""
        }&offset=${payload.offset ?? ""}`
      );

      if (res.status === 200) {
        yield put(StudentAction.getAllStudentsSuccess(res.data.data));
      } else {
        yield put(StudentAction.getAllStudentsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(StudentAction.getAllStudentsFailure());
    }
  }
  static *getStudentsAnalytics({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/school/get-students-analytics?schoolId=${payload?.schoolId}`
      );
      if (res.status === 200) {
        yield put(StudentAction.getStudentsAnalyticsSuccess(res.data.data));
      } else {
        yield put(StudentAction.getStudentsAnalyticsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(StudentAction.getStudentsAnalyticsFailure());
    }
  }
  static *getActiveStudents({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/school/get-active-students?schoolId=${payload?.schoolId}`
      );
      if (res.status === 200) {
        yield put(StudentAction.getActiveStudentsSuccess(res.data.data));
      } else {
        yield put(StudentAction.getActiveStudentsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(StudentAction.getActiveStudentsFailure());
    }
  }
  static *getStudentDetails({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/school/get-student-detail?userId=${payload.userId}`
      );
      if (res.status === 200) {
        yield put(StudentAction.getStudentDetailsSuccess(res.data.data));
      } else {
        yield put(StudentAction.getStudentDetailsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(StudentAction.getStudentDetailsFailure());
    }
  }
  static *updateStudent({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(
        `/school/update-student-by-school`,
        payload
      );
      if (res.status === 200) {
        yield put(StudentAction.updateStudentSuccess(res.data.data));
      } else {
        yield put(StudentAction.updateStudentFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(StudentAction.updateStudentFailure());
    }
  }
}
